import React, { Component } from "react";
import "./administrador.css";
import { Button, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Col, Input } from 'reactstrap';
import Utils from "../../Utils";
import { Cargando } from '../estados/Cargando';

function verificarSemaforosFactores(factores) {
    for (const factor of factores) {
        const {
            nombre,
            verdeDesde,
            verdeHasta,
            amarilloDesde,
            amarilloHasta,
            rojoDesde,
            rojoHasta
        } = factor;

        // 1) limite_inferior_verde > limite_superior_amarillo
        if (!(verdeDesde > amarilloHasta)) {
            alert(`Error en "${nombre}": verdeDesde (${verdeDesde}) debe ser mayor que amarilloHasta (${amarilloHasta})`);
            throw new Error(`Semáforo inválido en "${nombre}"`);
        }

        // 2) limite_superior_amarillo > limite_inferior_amarillo
        if (!(amarilloHasta > amarilloDesde)) {
            alert(`Error en "${nombre}": amarilloHasta (${amarilloHasta}) debe ser mayor que amarilloDesde (${amarilloDesde})`);
            throw new Error(`Semáforo inválido en "${nombre}"`);
        }

        // 3) limite_inferior_amarillo > limite_superior_rojo
        if (!(amarilloDesde > rojoHasta)) {
            alert(`Error en "${nombre}": amarilloDesde (${amarilloDesde}) debe ser mayor que rojoHasta (${rojoHasta})`);
            throw new Error(`Semáforo inválido en "${nombre}"`);
        }

        // 4) limite_superior_rojo > limite_inferior_rojo
        if (!(rojoHasta > rojoDesde)) {
            alert(`Error en "${nombre}": rojoHasta (${rojoHasta}) debe ser mayor que rojoDesde (${rojoDesde})`);
            throw new Error(`Semáforo inválido en "${nombre}"`);
        }
    }
}

export class Semaforos extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modalSem: props.modalSem,
            semaforos: {},
            estado: false,
            rol: props.rol
        };

        this.inputRef = React.createRef();
        this.inputRef2 = React.createRef();
    }

    componentDidMount() {
        this.getSemaforos();
    }

    toggle = () => {
        this.props.modalSem();
    }

    async getSemaforos() {
        this.setState({ estado: false })
        await Utils.getFactoresSuma()
            .then(data => {
                if (data !== undefined) {
                    let index = 0;
                    this.setState({ semaforos: data, estado: true })
                    for (let i = 0; i < data.length; i++) {
                        this.inputRef.current.elements[index + 0].value = data[i].id;
                        this.inputRef.current.elements[index + 1].value = data[i].nombre;
                        this.inputRef.current.elements[index + 2].value = data[i].semaforoVerde;
                        this.inputRef.current.elements[index + 3].value = data[i].verdeDesde;
                        this.inputRef.current.elements[index + 4].value = data[i].verdeHasta;
                        this.inputRef.current.elements[index + 5].value = data[i].semaforoAmarillo;
                        this.inputRef.current.elements[index + 6].value = data[i].amarilloDesde;
                        this.inputRef.current.elements[index + 7].value = data[i].amarilloHasta;
                        this.inputRef.current.elements[index + 8].value = data[i].semaforoRojo;
                        this.inputRef.current.elements[index + 9].value = data[i].rojoDesde;
                        this.inputRef.current.elements[index + 10].value = data[i].rojoHasta;
                        this.inputRef.current.elements[index + 11].value = data[i].textoBoton;
                        this.inputRef.current.elements[index + 12].value = data[i].vinculoBoton;
                        index += 13;
                    }
                    if (this.state.rol === "V") {
                        for (let j = 0, len = this.inputRef.current.elements.length; j < len; j++) {
                            this.inputRef.current.elements[j].readOnly = true;
                        }
                    }
                }
            })
        await Utils.getFactoresResta()
            .then(data => {
                if (data !== undefined) {
                    let index = 0;
                    for (let i = 0; i < data.length; i++) {
                        this.inputRef2.current.elements[index + 0].value = data[i].id;
                        this.inputRef2.current.elements[index + 1].value = data[i].nombre;
                        this.inputRef2.current.elements[index + 2].value = data[i].descripcionBien;
                        this.inputRef2.current.elements[index + 3].value = data[i].descripcionMal;
                        this.inputRef2.current.elements[index + 4].value = data[i].textoBoton;
                        this.inputRef2.current.elements[index + 5].value = data[i].vinculoBoton;
                        index += 6;
                    }
                    if (this.state.rol === "V") {
                        for (let j = 0, len = this.inputRef2.current.elements.length; j < len; j++) {
                            this.inputRef2.current.elements[j].readOnly = true;
                        }
                    }
                }
            })
    }

    async sendForm() {
        // Factores que suman
        // Construcción del array de objetos a partir de inputs del form
        const elems = Array.from(this.inputRef.current.elements).filter(e => e.name); // descarta botones sin name
        const groupSize = 13; // cantidad de campos por objeto
        const items = [];
        const isNumericString = s => /^-?\d+(\.\d+)?$/.test(String(s).trim());

        for (let i = 0; i < elems.length; i += groupSize) {

            const group = elems.slice(i, i + groupSize);
            const obj = {};
            group.forEach(el => {
                const raw = el.value ?? "";
                // convertir numéricos automáticamente (si el string es un número válido)
                obj[el.name] = isNumericString(raw) ? Number(raw) : raw;
            });

            items.push(obj);
        }

        // items es un array con los valores que se evaluan en el semaforo
        verificarSemaforosFactores(items);

        const payload = JSON.stringify(items);

        if (this.state.rol === "A") {
            await Utils.setFactoresSuma(payload);
        }

        // Factores que restan
        var index = 0;
        let json2 = "[";
        for (const elem of this.inputRef2.current.elements) {
            if (index === 0) json2 += "{";
            json2 += `"${elem.name}": "${elem.value}"`
            index++;
            if (index === 6) {
                json2 += "},";
                index = 0;
            }
            else json2 += ",";
        }
        json2 = json2.slice(0, -1) + "]";
        if (this.state.rol === "A")
            await Utils.setFactoresResta(json2)
    }

    actualizarValor(nuevoValor, i) {
        nuevoValor.value = nuevoValor.value.replace(/[^0-9]/g, '')
        if (Number(nuevoValor.value) > 99) nuevoValor.value = 99;
        if (Number(nuevoValor.value) < 3) nuevoValor.value = 2;
        this.inputRef.current.elements[i+4].value = Number(nuevoValor.value) - 1;
    }

    render() {
        return (
            <>
                {!this.state.estado ?? <div><Cargando></Cargando></div>}
                <ModalHeader toggle={() => this.toggle()}>Valores de Semaforos</ModalHeader>
                <ModalBody>
                    <form id="semForm" ref={this.inputRef}>
                        <table>
                            <tr>
                                <td colSpan="6" className="nombreEdit">
                                    <FormGroup row>
                                        <input type="hidden" name="id" />
                                        <Label for="nombreFactor" sm={1}>
                                            Nombre
                                        </Label>
                                        <Col sm={5}>
                                            <Input id="nombreFactor" name="nombre" type="text" />
                                        </Col>
                                    </FormGroup>
                                </td>
                            </tr>
                            <tr className="valoresEdit">
                                <td className="semV">
                                    <textarea rows="5" cols="20" name="semaforoVerde" />
                                </td>
                                <td className="semV">
                                    Desde: <input type="number" name="verdeDesde" max="100" min="3" onChange={(e) => this.actualizarValor(e.target,3)} />
                                    <br />
                                    Hasta:&nbsp; <input type="number" name="verdeHasta" max="100" min="0" disabled/>
                                </td>

                                <td className="semA">
                                    <textarea rows="5" cols="20" name="semaforoAmarillo" />
                                </td>
                                <td className="semA">
                                    Desde: <input type="number" name="amarilloDesde" max="100" min="2" onChange={(e) => this.actualizarValor(e.target,6)} />
                                    <br />
                                    Hasta:&nbsp; <input type="number" name="amarilloHasta" max="100" min="0" disabled/>
                                </td>

                                <td className="semR">
                                    <textarea rows="5" cols="20" name="semaforoRojo" />
                                </td>
                                <td className="semR">
                                    Desde: <input type="number" name="rojoDesde" max="100" min="0" disabled />
                                    <br />
                                    Hasta:&nbsp; <input type="number" name="rojoHasta" max="100" min="0" disabled/>
                                </td>
                                <input type="hidden" name="textoBoton" />
                                <input type="hidden" name="vinculoBoton" />
                            </tr>
                            <br />
                            <tr>
                                <td colSpan="6" className="nombreEdit">
                                    <FormGroup row>
                                        <input type="hidden" name="id" />
                                        <Label for="nombreFactor" sm={1}>
                                            Nombre
                                        </Label>
                                        <Col sm={5}>
                                            <Input id="nombreFactor" name="nombre" type="text" />
                                        </Col>
                                    </FormGroup>
                                </td>
                            </tr>
                            <tr className="valoresEdit">
                                <td className="semV">
                                    <textarea rows="5" cols="20" name="semaforoVerde" />
                                </td>
                                <td className="semV">
                                    Desde: <input type="number" name="verdeDesde" max="100" min="3" onChange={(e) => this.actualizarValor(e.target, 16)} />
                                    <br />
                                    Hasta:&nbsp; <input type="number" name="verdeHasta" max="100" min="0" disabled />
                                </td>

                                <td className="semA">
                                    <textarea rows="5" cols="20" name="semaforoAmarillo" />
                                </td>
                                <td className="semA">
                                    Desde: <input type="number" name="amarilloDesde" max="100" min="2" onChange={(e) => this.actualizarValor(e.target, 19)} />
                                    <br />
                                    Hasta:&nbsp; <input type="number" name="amarilloHasta" max="100" min="0" disabled />
                                </td>

                                <td className="semR">
                                    <textarea rows="5" cols="20" name="semaforoRojo" />
                                </td>
                                <td className="semR">
                                    Desde: <input type="number" name="rojoDesde" max="100" min="0" disabled />
                                    <br />
                                    Hasta:&nbsp; <input type="number" name="rojoHasta" max="100" min="0" disabled />
                                </td>
                                <input type="hidden" name="textoBoton" />
                                <input type="hidden" name="vinculoBoton" />
                            </tr>
                            <br />
                            <tr>
                                <td colSpan="6" className="nombreEdit">
                                    <FormGroup row>
                                        <input type="hidden" name="id" />
                                        <Label for="nombreFactor" sm={1}>
                                            Nombre
                                        </Label>
                                        <Col sm={5}>
                                            <Input id="nombreFactor" name="nombre" type="text" />
                                        </Col>
                                    </FormGroup>
                                </td>
                            </tr>
                            <tr className="valoresEdit">
                                <td className="semV">
                                    <textarea rows="5" cols="20" name="semaforoVerde" />
                                </td>
                                <td className="semV">
                                    Desde: <input type="number" name="verdeDesde" max="100" min="3" onChange={(e) => this.actualizarValor(e.target, 29)}/>
                                    <br />
                                    Hasta:&nbsp; <input type="number" name="verdeHasta" max="100" min="0" disabled />
                                </td>

                                <td className="semA">
                                    <textarea rows="5" cols="20" name="semaforoAmarillo" />
                                </td>
                                <td className="semA">
                                    Desde: <input type="number" name="amarilloDesde" max="100" min="2" onChange={(e) => this.actualizarValor(e.target, 32)}/>
                                    <br />
                                    Hasta:&nbsp; <input type="number" name="amarilloHasta" max="100" min="0" disabled />
                                </td>

                                <td className="semR">
                                    <textarea rows="5" cols="20" name="semaforoRojo" />
                                </td>
                                <td className="semR">
                                    Desde: <input type="number" name="rojoDesde" max="100" min="0" disabled />
                                    <br />
                                    Hasta:&nbsp; <input type="number" name="rojoHasta" max="100" min="0" disabled />
                                </td>
                                <input type="hidden" name="textoBoton" />
                                <input type="hidden" name="vinculoBoton" />
                            </tr>
                            <br />
                            <tr>
                                <td colSpan="6" className="nombreEdit">
                                    <FormGroup row>
                                        <input type="hidden" name="id" />
                                        <Label for="nombreFactor" sm={1}>
                                            Nombre
                                        </Label>
                                        <Col sm={5}>
                                            <Input id="nombreFactor" name="nombre" type="text" />
                                        </Col>
                                    </FormGroup>
                                </td>
                            </tr>
                            <tr className="valoresEdit">
                                <td className="semV">
                                    <textarea rows="5" cols="20" name="semaforoVerde" />
                                </td>
                                <td className="semV">
                                    Desde: <input type="number" name="verdeDesde" max="100" min="3" onChange={(e) => this.actualizarValor(e.target, 42)} />
                                    <br />
                                    Hasta:&nbsp; <input type="number" name="verdeHasta" max="100" min="2" disabled />
                                </td>

                                <td className="semA">
                                    <textarea rows="5" cols="20" name="semaforoAmarillo" />
                                </td>
                                <td className="semA">
                                    Desde: <input type="number" name="amarilloDesde" max="100" min="0" onChange={(e) => this.actualizarValor(e.target, 45)} />
                                    <br />
                                    Hasta:&nbsp; <input type="number" name="amarilloHasta" max="100" min="0" disabled />
                                </td>

                                <td className="semR">
                                    <textarea rows="5" cols="20" name="semaforoRojo" />
                                </td>
                                <td className="semR">
                                    Desde: <input type="number" name="rojoDesde" max="100" min="0" disabled />
                                    <br />
                                    Hasta:&nbsp; <input type="number" name="rojoHasta" max="100" min="0" disabled />
                                </td>
                                <input type="hidden" name="textoBoton" />
                                <input type="hidden" name="vinculoBoton" />
                            </tr>
                            <br />
                            <tr>
                                <td colSpan="6" className="nombreEdit">
                                    <FormGroup row>
                                        <input type="hidden" name="id" />
                                        <Label for="nombreFactor" sm={1}>
                                            Nombre
                                        </Label>
                                        <Col sm={5}>
                                            <Input id="nombreFactor" name="nombre" type="text" />
                                        </Col>
                                    </FormGroup>
                                </td>
                            </tr>
                            <tr className="valoresEdit">
                                <td className="semV">
                                    <textarea rows="5" cols="20" name="semaforoVerde" />
                                </td>
                                <td className="semV">
                                    Desde: <input type="number" name="verdeDesde" max="100" min="3" onChange={(e) => this.actualizarValor(e.target, 55)} />
                                    <br />
                                    Hasta:&nbsp; <input type="number" name="verdeHasta" max="100" min="0" disabled />
                                </td>

                                <td className="semA">
                                    <textarea rows="5" cols="20" name="semaforoAmarillo" />
                                </td>
                                <td className="semA">
                                    Desde: <input type="number" name="amarilloDesde" max="100" min="2" onChange={(e) => this.actualizarValor(e.target, 58)} />
                                    <br />
                                    Hasta:&nbsp; <input type="number" name="amarilloHasta" max="100" min="0" disabled />
                                </td>

                                <td className="semR">
                                    <textarea rows="5" cols="20" name="semaforoRojo" />
                                </td>
                                <td className="semR">
                                    Desde: <input type="number" name="rojoDesde" max="100" min="0" disabled />
                                    <br />
                                    Hasta:&nbsp; <input type="number" name="rojoHasta" max="100" min="0" disabled />
                                </td>
                                <input type="hidden" name="textoBoton" />
                                <input type="hidden" name="vinculoBoton" />
                            </tr>
                            <br />
                            <tr>
                                <td colSpan="6" className="nombreEdit">
                                    <FormGroup row>
                                        <input type="hidden" name="id" />
                                        <Label for="nombreFactor" sm={1}>
                                            Nombre
                                        </Label>
                                        <Col sm={5}>
                                            <Input id="nombreFactor" name="nombre" type="text" />
                                        </Col>
                                    </FormGroup>
                                </td>
                            </tr>
                            <tr className="valoresEdit">
                                <td className="semV">
                                    <textarea rows="5" cols="20" name="semaforoVerde" />
                                </td>
                                <td className="semV">
                                    Desde: <input type="number" name="verdeDesde" max="100" min="3" onChange={(e) => this.actualizarValor(e.target, 68)} />
                                    <br />
                                    Hasta:&nbsp; <input type="number" name="verdeHasta" max="100" min="0" disabled />
                                </td>

                                <td className="semA">
                                    <textarea rows="5" cols="20" name="semaforoAmarillo" />
                                </td>
                                <td className="semA">
                                    Desde: <input type="number" name="amarilloDesde" max="100" min="2" onChange={(e) => this.actualizarValor(e.target, 71)} />
                                    <br />
                                    Hasta:&nbsp; <input type="number" name="amarilloHasta" max="100" min="0" disabled />
                                </td>

                                <td className="semR">
                                    <textarea rows="5" cols="20" name="semaforoRojo" />
                                </td>
                                <td className="semR">
                                    Desde: <input type="number" name="rojoDesde" max="100" min="0" disabled />
                                    <br />
                                    Hasta:&nbsp; <input type="number" name="rojoHasta" max="100" min="0" disabled />
                                </td>
                                <input type="hidden" name="textoBoton" />
                                <input type="hidden" name="vinculoBoton" />
                            </tr>
                            <br />
                            <tr>
                                <td colSpan="6" className="nombreEdit">
                                    <FormGroup row>
                                        <input type="hidden" name="id" />
                                        <Label for="nombreFactor" sm={1}>
                                            Nombre
                                        </Label>
                                        <Col sm={5}>
                                            <Input id="nombreFactor" name="nombre" type="text" />
                                        </Col>
                                    </FormGroup>
                                </td>
                            </tr>
                            <tr className="valoresEdit">
                                <td className="semV">
                                    <textarea rows="5" cols="20" name="semaforoVerde" />
                                </td>
                                <td className="semV">
                                    Desde: <input type="number" name="verdeDesde" max="100" min="3" onChange={(e) => this.actualizarValor(e.target, 81)} />
                                    <br />
                                    Hasta:&nbsp; <input type="number" name="verdeHasta" max="100" min="0" disabled />
                                </td>

                                <td className="semA">
                                    <textarea rows="5" cols="20" name="semaforoAmarillo" />
                                </td>
                                <td className="semA">
                                    Desde: <input type="number" name="amarilloDesde" max="100" min="2" onChange={(e) => this.actualizarValor(e.target, 84)} />
                                    <br />
                                    Hasta:&nbsp; <input type="number" name="amarilloHasta" max="100" min="0" disabled />
                                </td>

                                <td className="semR">
                                    <textarea rows="5" cols="20" name="semaforoRojo" />
                                </td>
                                <td className="semR">
                                    Desde: <input type="number" name="rojoDesde" max="100" min="0" disabled />
                                    <br />
                                    Hasta:&nbsp; <input type="number" name="rojoHasta" max="100" min="0" disabled />
                                </td>
                                <input type="hidden" name="textoBoton" />
                                <input type="hidden" name="vinculoBoton" />
                            </tr>
                            <br />

                        </table>
                    </form>
                    <form id="semForm2" ref={this.inputRef2}>
                        <table>
                            <tr>
                                <td colSpan="2" className="nombreEdit">
                                    <FormGroup row>
                                        <input type="hidden" name="id" />
                                        <Label for="nombreFactor" sm={2}>
                                            Nombre
                                        </Label>
                                        <Col sm={9}>
                                            <Input id="nombreFactor" name="nombre" type="text" />
                                        </Col>
                                    </FormGroup>
                                </td>
                            </tr>
                            <tr className="valoresEdit">
                                <td className="semN">
                                    <textarea rows="5" cols="20" name="descripcionBien" />
                                </td>
                                <td className="semN">
                                    <textarea rows="5" cols="20" name="descripcionMal" />
                                </td>
                                <input type="hidden" name="textoBoton" />
                                <input type="hidden" name="vinculoBoton" />
                            </tr>
                            <br />
                            <tr>
                                <td colSpan="2" className="nombreEdit">
                                    <FormGroup row>
                                        <input type="hidden" name="id" />
                                        <Label for="nombreFactor" sm={2}>
                                            Nombre
                                        </Label>
                                        <Col sm={9}>
                                            <Input id="nombreFactor" name="nombre" type="text" />
                                        </Col>
                                    </FormGroup>
                                </td>
                            </tr>
                            <tr className="valoresEdit">
                                <td className="semN">
                                    <textarea rows="5" cols="20" name="descripcionBien" />
                                </td>
                                <td className="semN">
                                    <textarea rows="5" cols="20" name="descripcionMal" />
                                </td>
                                <input type="hidden" name="textoBoton" />
                                <input type="hidden" name="vinculoBoton" />
                            </tr>
                            <br />
                            <tr>
                                <td colSpan="2" className="nombreEdit">
                                    <FormGroup row>
                                        <input type="hidden" name="id" />
                                        <Label for="nombreFactor" sm={2}>
                                            Nombre
                                        </Label>
                                        <Col sm={9}>
                                            <Input id="nombreFactor" name="nombre" type="text" />
                                        </Col>
                                    </FormGroup>
                                </td>
                            </tr>
                            <tr className="valoresEdit">
                                <td className="semN">
                                    <textarea rows="5" cols="20" name="descripcionBien" />
                                </td>
                                <td className="semN">
                                    <textarea rows="5" cols="20" name="descripcionMal" />
                                </td>
                                <input type="hidden" name="textoBoton" />
                                <input type="hidden" name="vinculoBoton" />
                            </tr>
                            <br />
                        </table>
                    </form>
                </ModalBody>
                <ModalFooter>
                    {this.state.rol === "A" ?
                        <Button color="primary" onClick={() => this.sendForm()}>
                            Guardar
                        </Button> :null
                    }
                    {' '}
                    <Button color="secondary" onClick={() => this.toggle()}>
                        Cerrar
                    </Button>
                </ModalFooter>
            </>
        );
    }
}
